import React, {useState} from "react";

export default function SupportedInputs() {
    const inputs = [
        { type: "Text", tag: "text, number, email, tel, url", support: "✅", description: "Standard text input" },
        { type: "Select", tag: "<select></select>", support: "✅", description: "Select box inputs" },
        { type: "Radio", tag: "radio", support: "✅", description: "Single-choice selection inputs" },
        { type: "Checkbox", tag: "checkbox", support: "✅", description: "Selection inputs" },
        { type: "Color", tag: "color", support: "✅", description: "Choose a color from a picker" },
        { type: "Range", tag: "range", support: "✅", description: "Select a value within a range" },
        { type: "Datetime", tag: "date, time, datetime-local", support: "✅", description: "Date Time inputs" },
        { type: "Textarea", tag: "<textarea></textarea>", support: "✅", description: "Multi-line text inputs" },
        { type: "Password", tag: "password", support: "✅", description: "Ensure user privacy and security" },
        { type: "File Upload", tag: "file", support: "❌", description: "Upload file inputs" }
    ];

    const [expanded, setExpanded] = useState(false);
    const visibleInputs = expanded ? inputs : inputs.slice(0, 6);

    return (
        <section id="contact-us" className="bg-white dark:bg-gray-800 flex justify-center px-4 sm:px-6 lg:px-8">
            <div className="py-8 pb-12 mx-auto w-full max-w-4xl">
                <div className="mx-auto max-w-screen-md text-center mb-8 lg:mb-8">
                    <h2 className="mb-4 text-3xl sm:text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">
                        Supported Input Types
                    </h2>
                    <p className="mb-3 font-light text-sm sm:text-lg text-gray-900 dark:text-white">
                        Below is a list of input types we currently support, with more on the way!
                    </p>
                </div>
                <div className="relative overflow-x-auto shadow-sm sm:rounded-lg">
                    <table className="w-full text-xs sm:text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" className="px-4 sm:px-6 py-3">Input Type</th>
                            <th scope="col" className="px-4 sm:px-6 py-3">Tag</th>
                            <th scope="col" className="px-4 sm:px-6 py-3">Supported?</th>
                            <th scope="col" className="px-4 sm:px-6 py-3">Details</th>
                        </tr>
                        </thead>
                        <tbody>
                        {visibleInputs.map((input, index) => (
                            <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200">
                                <th scope="row" className="px-4 sm:px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                    {input.type}
                                </th>
                                <td className="px-4 sm:px-6 py-4">{input.tag}</td>
                                <td className="px-4 sm:px-6 py-4">{input.support}</td>
                                <td className="px-4 sm:px-6 py-4">{input.description}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <div className="text-center mt-5">
                    <button
                        onClick={() => setExpanded(!expanded)}
                        className="btn btn-default">
                        {expanded ? "Show Less" : "Show More"}
                    </button>
                </div>
            </div>
        </section>
    );
}
